import React, {useEffect, useState} from 'react'
import API from '../../services/api'
import { getGenerateUrl } from '../../utils/constants';
import BirdViewData from './BirdViewData';
import ReportBirdview from './ReportBirdview';

function DashBoardStats() {
    const [loader, setLoader] = useState(false)
  const [newsPaperData, setNewsPaperData] = useState([]);
  const [stats, setStats] = useState([])
  const [selected, setSelected] = useState({})
  const [reportId, SetReportId] = useState(0)
  const [showReport, setShowReport] = useState(false)
  const [imageUrl, setImageUrl] = useState('')
    const fetchStats = async() =>{
        setLoader(true)
        try {
            let res = await API({
                url:'/sales_dashboard/dashboardStats',
                method:'POST',
                responseType:'json',
                data:{}
            })
            if(res.code === 200){
                setStats(res.data)
            }
        } catch (error) {
            console.error(error)
        }
        finally{
            setLoader(false)
        }
    }
    const fetchNewsPapers = async() =>{
        try {
          let res = await API({
            url: "/market/newspapers",
            method: "POST",
            responseType:'json',
            data:{}
          })
          if(res.code === 200){
            setNewsPaperData([...res.data])
          }
        } catch (error) {
          console.error(error)
        }
      }
    const getLogo = (brand) =>{
        const brandLookup = newsPaperData.filter(np => np.name === brand)
        return brandLookup?.[0]?.logo
      }
    useEffect(() => {
        fetchNewsPapers()
      fetchStats()
    }, [])

    const getBrandBBV = async(brand, record_date) => {
      try {
        let startDate = new Date(record_date)
        let endDate = new Date(record_date)
        endDate.setHours(23,59,59,59)
        let obj = {date :{startDate, endDate}, record_date, brand_id: brand.brand_id, sales_person_id: brand.sales_person_id}
        setSelected(obj)
      } catch (error) {
        console.error("Error @ getBrandBBV", error)
      }

    }
  const getDateMeta = (dateStr) => {
    const d = new Date(dateStr); d.setHours(0, 0, 0, 0);
    const today = new Date(); today.setHours(0, 0, 0, 0);
    const diff = Math.round((today - d) / 86400000);
    const wd = d.toLocaleDateString("default", { weekday: "short" });
    const md = d.toLocaleDateString("default", { month: "short", day: "numeric" });
    return { title: `${wd} · ${md}`, badge: diff === 0 ? "TODAY" : diff === 1 ? "YESTERDAY" : null };
  };
  return (
    <>
    <div className='flex flex-col gap-4 mt-2 dashboard_stats'>
    {!loader && stats?.length > 0 ? stats.map((record, index) => {
        const { title, badge } = getDateMeta(record.date);
        return (
        <div className='border border-gray-200 rounded-xl bg-white overflow-hidden' key={index}>
          <div className='p-3'>
            <div className='flex items-center gap-2 mb-3'>
              <span className='font-semibold text-[#1f2430]'>{title}</span>
              {badge && (
                <span className={`text-[10px] font-semibold px-2 py-0.5 rounded-full ${badge === "TODAY" ? "bg-[#E5EBFF] text-[#4952FA]" : "bg-gray-100 text-gray-500"}`}>{badge}</span>
              )}
            </div>
            <div className='grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-2 sm:gap-3'>
            {record.records?.map((brand, idx) => (
                <div
                  className={'flex items-center gap-2 border border-gray-200 rounded-xl p-2 cursor-pointer transition-shadow hover:shadow-sm dashboard-brand' + (brand.brand_id === selected?.brand_id && record.date === selected.record_date ? ' active' : '')}
                  key={idx}
                  onClick={() => {setSelected({});getBrandBBV(brand, record.date)}}
                >
                    <img className='w-7 h-7 rounded-full object-contain bg-gray-100 p-0.5 shrink-0' src={brand.url || getGenerateUrl(brand.brand_name)} alt='L'></img>
                    <h6 title={brand.brand_name} className='truncate text-sm font-medium mb-0 flex-1 min-w-0'>{brand.brand_name}</h6>
                    <div className="flex items-center gap-1 shrink-0">
                        {brand?.camp_targets?.map((item, i2) => (
                            <img key={i2} className="w-5 h-5" src={getLogo(item)} alt="logo" />
                        ))}
                        {brand?.w2n_spent !== "0.00" ? <img className="w-5 h-5" src={getLogo('Way2news')} alt="notexist" /> : null}
                    </div>
                </div>
            ))}
            </div>
          </div>
            {Object.keys(selected)?.length && record.date === selected.record_date ? <div className='border-top'>
            <BirdViewData brand={selected.brand_id} salesPerson_id={selected.sales_person_id} date={selected.date}  fetchW2n={true} fetchAllNews={true} setReportId={SetReportId} setShowReport={setShowReport} setImageUrl={setImageUrl}/>
            </div> :null}
        </div>
        );
    }) : <div className="flex flex-col items-center justify-center py-10 text-gray-400 w-full">
        <svg data-v-5eed88b5="" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" className="bird-icon flip"><path d="M16 7h.01"></path><path d="M3.4 18H12a8 8 0 0 0 8-8V7a4 4 0 0 0-7.28-2.3L2 20"></path><path d="m20 7 2 .5-2 .5"></path><path d="M10 18v3"></path><path d="M14 17.75V21"></path><path d="M7 18a6 6 0 0 0 3.84-10.61"></path></svg>
        <h2>No Data Found</h2></div>}
</div>
<ReportBirdview open={showReport} setOpen={setShowReport} reportId={reportId} image_url={imageUrl}/>

    </>
  )
}

export default DashBoardStats
